import { useMemo } from 'react';
import { DropDownFilter, DropDownFilterProps } from 'framework/list';
import { Dropdown } from 'framework/form';
import type { HeatmapTeamMember } from '../helpers';
import { useEmployeeNamesByAliases } from '../useEmployeeNamesByAliases';
import { buildEmployeeLastNameFirst, buildEmployeeLastNameSortKey } from '../employeeName';

interface ProjectTeamMemberMultiSelectFilterProps extends Omit<DropDownFilterProps, 'children'> {
  members: HeatmapTeamMember[];
}

const ProjectTeamMemberMultiSelectFilter = ({
  members,
  source,
  label,
  ...props
}: ProjectTeamMemberMultiSelectFilterProps) => {
  const aliases = useMemo(() => members.map(m => m.employeeAlias).filter(Boolean), [members]);
  const namesByAlias = useEmployeeNamesByAliases(aliases);

  const options = useMemo(
    () =>
      members
        .map(m => ({
          value: m.employeeAlias,
          label: buildEmployeeLastNameFirst(m.employeeAlias, namesByAlias[m.employeeAlias]),
        }))
        .sort((a, b) =>
          buildEmployeeLastNameSortKey(a.value, namesByAlias[a.value]).localeCompare(
            buildEmployeeLastNameSortKey(b.value, namesByAlias[b.value]),
          ),
        ),
    [members, namesByAlias],
  );

  return (
    <DropDownFilter {...props} source={source} label={label}>
      <Dropdown source={source} label={label} options={options} placeholder="Select..." />
    </DropDownFilter>
  );
};

export default ProjectTeamMemberMultiSelectFilter;
